/**
 * The environments a solution can be published to.
 *
 * This used to come from Bot Manager's `getListEnvs`, which now answers "Input payload
 * validation failed" — the list is a fixed pair in the Agent Manager schema
 * (`SolutionEnvironmentsEnum` = live | sandbox), so there is nothing to fetch.
 *
 * Order matters: `sandbox` first is the order the publish modal defaults to, and the
 * republish modal reverses this list to show `live` first.
 */
export const SOLUTION_ENVIRONMENTS: string[] = ['sandbox', 'live'];
